// Added the breakpoints we use in css to be able to apply js logic depending on
// viewport width.
// Example: showing/hiding a second save button in the device manager's timer
//          but only show it on mobile if the list of displayed time slots is
//          long. Otherwise the button above and below would be visible which
//          looks weird / like a bug.
const BP_XS = 400
const BP_SSM = 500
const BP_SM = 600
const BP_MD = 768
const BP_ML = 850
const BP_LG = 992
const BP_XL = 1100
const BP_XXL = 1200

const COLOR_PRIMARY = process.env.VUE_APP_SCSS_COLOR_COMMUNITY

const MAX_MARKERS_MOBILE = 100
const MAX_MARKERS_DESKTOP = 300
const MAX_MARKERS_BREAKPOINT = 500

const MARKER_SETTINGS = {
  producer: {
    width: 40,
    height: 40,
    anchor: {
      x: 20,
      y: 40,
    },
    labelOffset: 8,
  },
  consumer: {
    width: 36,
    height: 36,
    anchor: {
      x: 18,
      y: 18,
    },
    labelOffset: 8,
  },
}

const SENSOR_DATA_POWER = 1
const SENSOR_DATA_TEMPERATURE = 3
const SENSOR_DATA_IS_ON = 4

const DEVICE_STATUS_SWITCHED_OFF = 1
const DEVICE_STATUS_SWITCHED_ON = 2
const DEVICE_STATUS_NOT_REACHABLE = 3
const DEVICE_MODE_CHANGED_TO_MEASURE = 4

export {
  BP_XS,
  BP_SSM,
  BP_SM,
  BP_MD,
  BP_ML,
  BP_LG,
  BP_XL,
  BP_XXL,
  COLOR_PRIMARY,
  MAX_MARKERS_MOBILE,
  MAX_MARKERS_DESKTOP,
  MAX_MARKERS_BREAKPOINT,
  MARKER_SETTINGS,
  SENSOR_DATA_TEMPERATURE,
  SENSOR_DATA_POWER,
  SENSOR_DATA_IS_ON,
  DEVICE_STATUS_SWITCHED_OFF,
  DEVICE_STATUS_SWITCHED_ON,
  DEVICE_STATUS_NOT_REACHABLE,
  DEVICE_MODE_CHANGED_TO_MEASURE,
}
